import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { PmgMemberProfile } from '../../../../../models/PmgMembershipProfile/PmgMemberProfile';

interface PmgMembershipGeneralProfileProps {
    memberProfile: PmgMemberProfile;
}

const PmgMembershipGeneralProfile: React.FC<
    PmgMembershipGeneralProfileProps
> = ({ memberProfile }) => {
    return (
        <div className="profile-view-pop-up-body">
            <div className="delete-image-div">
                <div className="poc-avatar-icon">
                    <div className="avatar-icon-wrapper">
                        <div
                            className="avatar-member-icon"
                            style={{
                                background: memberProfile?.backgroundColorCode,
                            }}>
                            <div
                                className="avatar-member-initials"
                                style={{
                                    color: memberProfile?.foregroundColorCode,
                                }}>
                                {(
                                    memberProfile?.firstName.charAt(0) +
                                    memberProfile?.lastName.charAt(0)
                                )?.toUpperCase()}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="profile-view-wrapper center">
                    <div className="status-title left">
                        <div className="input-title">Former PMG Member</div>
                    </div>
                </div>
                <div
                    className="name-wrapper"
                    style={{
                        paddingBottom: '7px',
                        paddingTop: '0',
                    }}>
                    <h2>
                        {`${memberProfile?.firstName} ${memberProfile?.lastName}`}
                    </h2>
                </div>
                <Row className="input-title">
                    <Col md={12}>
                        <label>Practice</label>
                    </Col>
                    <Col md={12}>
                        {memberProfile?.profile?.practices?.length ? (
                            memberProfile?.profile.practices.map(
                                (practice, index) => (
                                    <div
                                        className="input-title mb-space-5"
                                        key={index}>
                                        <span>
                                            {practice.website ? (
                                                <Link
                                                    target={'_blank'}
                                                    to={
                                                        '//' + practice.website
                                                    }>
                                                    {practice.name}
                                                </Link>
                                            ) : (
                                                practice.name
                                            )}
                                            , {practice.roleName}
                                            <br />
                                        </span>
                                    </div>
                                )
                            )
                        ) : (
                            <div className="input-title">N/A</div>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default PmgMembershipGeneralProfile;
